import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  private readonly tag: string = "G-SY2HGV0273";

  constructor() {
    if (environment.enableAnalytics) {
      this.loadAnalyticsScript();
    }
  }

  private loadAnalyticsScript() {
    window['dataLayer'] = window['dataLayer'] || [];
    window['gtag'] = function () {
      window['dataLayer'].push(arguments);
    };
    window['gtag']('js', new Date());
    window['gtag']('config', this.tag);

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${this.tag}`;
    document.head.appendChild(script);
  }
}